import { User, SigninRequest } from "@/types/auth";
import instance from "@/services/api";

export const signin = async (signinData: SigninRequest) => instance.post("/maru/user/api/user/login", signinData);

export const signout = async () => instance.post("/maru/user/api/user/logout");

export const getUserInfo = async () => {
  const response = await instance.get<User>("/maru/user/api/mypage/profile");

  return response.data;
};

export const sendResetPasswordEmail = async (email: string) =>
  instance.post("/maru/user/api/user/password-reset", { email });
export const resetPassword = async (password: string, token: string) =>
  instance.patch("/maru/user/api/user/password-reset", { new_password: password, token });
export const verifyToken = async (token: string) => instance.post("/maru/user/api/account/password/token", { token });
